import { html } from 'lit';
import '../../library/elements/d-section';
import '../../library/fields/d-view-html';
import './d-promo-section';
import { customElement, property } from 'lit/decorators.js';
import { BaseDialog } from 'src/library/components/BaseDialog';
import type { OrganizationViewModelSpecialTermsEnum } from '@trinnvis/dabih-api-client';
import type { Promo } from '../../store/selectors/promo-type';
import type { Feature } from '../../store/selectors/features/feature';
import type { PromoDialogResult } from './promo-dialog-result';
import type { PromoDialogInput } from './promo-dialog-input';
import type { SelectDropdownOption } from '../editors/elements/select-dropdown-option';

/**
 *
 * STATUS OK
 */
@customElement('d-promo-dialog')
export class DPromoDialog extends BaseDialog<PromoDialogInput, PromoDialogResult> {
  @property({ type: Number })
  width = 600;
  @property({ type: Boolean })
  noHeader = true;
  @property({ type: Boolean, attribute: 'no-footer', reflect: true })
  noFooter = true;
  @property({ type: Boolean })
  cancelOnOutsideClick = true;
  @property({ type: Object })
  promoData!: Promo;
  @property({ type: Array })
  features: Feature[] = [];
  @property({ type: Number })
  employeesCount = 1;
  @property({ type: String })
  specialTerms: OrganizationViewModelSpecialTermsEnum | undefined = undefined;
  @property({ type: String })
  selectedFeature = '';
  @property({ type: Array })
  healthcareSignatoryOptions: SelectDropdownOption[] = [];
  @property({ type: String })
  healthcareSignatory: string | undefined = undefined;
  @property({ type: Boolean })
  canUpgrade = false;
  @property({ type: Boolean })
  hasHealthcare = false;

  protected get hideCloser() {
    return true;
  }
  renderBody() {
    return html`<d-promo-section
      dialog
      .employeesCount=${this.employeesCount}
      .specialTerms=${this.specialTerms}
      .promoData=${this.promoData}
      .features=${this.features}
      .healthcareSignatoryOptions=${this.healthcareSignatoryOptions}
      .healthcareSignatory=${this.healthcareSignatory}
      .canUpgrade=${this.canUpgrade}
      .hasHealthcare=${this.hasHealthcare}
      @add-features=${() => this.onUpgrade()}
      @cancel=${(e) => this.onClose(e)}
    ></d-promo-section>`;
  }

  protected renderFooter() {
    return html``;
  }

  protected onUpgrade() {
    this.onDispatchAction(false, 'upgrade');
  }

  protected fetchResult(detail: 'cancel' | 'upgrade'): PromoDialogResult {
    return {
      action: detail,
    };
  }

  protected initializeDialog(input: PromoDialogInput) {
    this.promoData = input.promoData;
    this.features = input.features;
    this.employeesCount = input.employeesCount;
    this.specialTerms = input.specialTerms;
    this.healthcareSignatoryOptions = input.healthcareSignatoryOptions;
    this.healthcareSignatory = input.healthcareSignatory;
    this.canUpgrade = input.canUpgrade;
    this.hasHealthcare = input.hasHealthcare ?? false;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'd-promo-dialog': DPromoDialog;
  }
}
